import React from 'react';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  wrapperContainer: {
    padding: '0.3rem',
    backgroundColor: '#E5E5E5'
  }
});
const TableWrapper = ({ children }: { children: any }) => {
  const classes = useStyles();
  return (
    <Grid container className={classes.wrapperContainer}>
      {children}
    </Grid>
  );
};

export default TableWrapper;
